import React from 'react';
import { motion } from 'framer-motion';
import { categories } from '../data/quizData';

const ScoreChart = ({ scores }) => {
  const maxScore = 20;

  return (
    <div className="space-y-2 sm:space-y-3 md:space-y-4">
      {scores.map((scoreData, index) => {
        const percentage = (scoreData.score / maxScore) * 100;
        const isTopThree = index < 3;

        return (
          <motion.div
            key={scoreData.category}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
            className={`p-2 sm:p-3 md:p-4 rounded-lg ${
              isTopThree ? 'bg-yellow bg-opacity-10 border border-yellow' : 'bg-gray-50'
            }`}
          >
            <div className="flex justify-between items-center mb-1 sm:mb-2">
              <h4 className={`text-xs sm:text-sm md:text-base font-semibold ${
                isTopThree ? 'text-midnight-blue' : 'text-gray-700'
              }`}>
                {categories[scoreData.category]}
              </h4>
              <span className={`text-xs sm:text-sm md:text-base font-bold ${
                isTopThree ? 'text-midnight-blue' : 'text-gray-600'
              }`}>
                {scoreData.score}/20
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 sm:h-3">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${percentage}%` }}
                transition={{ delay: index * 0.1 + 0.3, duration: 0.8, ease: "easeOut" }}
                className={`h-2 sm:h-3 rounded-full ${
                  isTopThree ? 'bg-gradient-to-r from-yellow to-orange-400' : 'bg-md-blue'
                }`}
              />
            </div>
            <div className="text-right mt-0.5 sm:mt-1">
              <span className={`text-xs sm:text-sm ${
                isTopThree ? 'text-midnight-blue font-semibold' : 'text-gray-500'
              }`}>
                {Math.round(percentage)}%
              </span>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default ScoreChart;